(() => {
  'use strict';

  // Loox's sidebar label does not support its multilingual setting.
  if (document.documentElement.lang.split('-')[0].toLowerCase() !== 'en') return;

  const translate = () => {
    const button = document.getElementById('loox-floating-widget-btn');
    if (!button) return;

    // Keep the icon, element, and Loox click handlers intact.
    const walker = document.createTreeWalker(button, NodeFilter.SHOW_TEXT);
    let node;
    while ((node = walker.nextNode())) {
      if (/^(Yorumlar|Yorum)$/i.test(node.nodeValue.trim())) {
        node.nodeValue = node.nodeValue.replace(/Yorumlar|Yorum/i, 'Reviews');
      }
    }
    if (button.getAttribute('aria-label') !== 'Reviews') {
      button.setAttribute('aria-label', 'Reviews');
    }
  };

  // The app inserts the button asynchronously and can recreate it later.
  const observer = new MutationObserver(translate);
  observer.observe(document.body, { childList: true, subtree: true, characterData: true });
  translate();
})();
